import { Skeleton } from '@/components/custom';

type TProps = {
	count?: number;
};

const DataTableMobileSkeleton = ({ count = 5 }: TProps) => {
	const skeletonKeys = Array.from({ length: count }, () => crypto.randomUUID());

	return (
		<div className="space-y-4">
			{skeletonKeys.map(key => (
				<div key={key} className="p-4 border rounded-lg bg-card text-card-foreground shadow-xs">
					<div className="flex items-start justify-between">
						<div className="space-y-2 flex-1 mr-4">
							<div className="flex flex-col items-start gap-1">
								<Skeleton className="h-4 w-12 rounded-full" />
								<Skeleton className="h-3 w-20 rounded-full" />
							</div>
							<Skeleton className="h-4 w-3/4 rounded-sm" />
						</div>
						<div className="flex items-start gap-3">
							<div className="flex flex-col items-end space-y-2">
								<Skeleton className="h-5 w-20" />
								<Skeleton className="h-3 w-16" />
							</div>
						</div>
					</div>
				</div>
			))}
		</div>
	);
};

export default DataTableMobileSkeleton;
